import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
   private baseUrl = `${environment.baseUrl}`;
  private apiUrl = `${environment.baseUrl}`; // Replace with your backend URL
  private currentUser: any = null;


  
  constructor(private http: HttpClient, private router: Router,  private commonAPI: CommonApiService) { }
  login(loginid: string, password: string): Observable<any> {
    const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        const body = {
          "criteria": {
            "loginid": loginid,
            "password":password,
            "tenant": null
          }
        };
    
    return this.http.post(`${this.apiUrl}/auth/login`, body);
  // return this.commonAPI.postApiCall(`${this.baseUrl}/auth/login`, body);
  }
  setUser(user: any) {
    this.currentUser = user;
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser() {
    if (!this.currentUser) {
      this.currentUser = JSON.parse(localStorage.getItem('user') || 'null');
    }
    return this.currentUser;
  }

  isLoggedIn() {
    return !!this.getUser();
  }

  getUserRole(): string {
    return this.getUser()?.user_type || '';
  }
  /** Clear session and tokens used by the app (login stores authToken + user id via setUser). */
  logout(): void {
    this.currentUser = null;
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
  }

  storeSession(user: any, token: string): void {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }
}
